import React from 'react';
import IconContainer from '@components/common/IconContainer';
import CloseIcon from '@asset/svg/CloseIcon';
import { DraggableData, DraggableEvent } from 'react-draggable';
import { ScheduledMessage } from '@asset/type/chat';
import ChatPopupWrapper from '../ChatPopupWrapper';
import CancelFillIcon from '@asset/svg/CancelFillIcon';
import { DateTime } from 'luxon';
import BasicButton from '@components/common/button/BasicButton';
import * as S from '@styles/chat/scheduleMessage.style';

const ScheduledMessageListPopup = ({
  popupRef,
  messagesList,
  defaultPosition,
  isTablet,
  onSelectMessage,
  onClosePopup,
  handleDrag,
  onDeleteMessage,
  onClickResetMessageFormButton,
}: {
  popupRef: React.RefObject<HTMLDivElement>;
  messagesList: ScheduledMessage[];
  defaultPosition: { x: string; y: string };
  isTablet: boolean;
  onSelectMessage: (message: ScheduledMessage) => void;
  onClosePopup: () => void;
  handleDrag: (e: DraggableEvent, data: DraggableData) => void;
  onDeleteMessage: (message: ScheduledMessage) => void;
  onClickResetMessageFormButton: () => void;
}) => {
  return (
    <ChatPopupWrapper
      draggableCoreProps={{ onDrag: handleDrag }}
      popupRef={popupRef}
      defaultPosition={defaultPosition}
      rndProps={{
        enableResizing: { bottom: !isTablet },
      }}
    >
      <section className="flex flex-col h-full">
        <S.ScheduledMessagePopupHeader className="drag-handle">
          <div className="middle title">예약 목록</div>
          <IconContainer
            icon={<CloseIcon width="20" height="20" color="var(--gray-10)" />}
            size={'M'}
            onClick={() => onClosePopup()}
          />
        </S.ScheduledMessagePopupHeader>
        <div className="flex-grow overflow-y-auto">
          <div className="flex flex-col gap-2 h-fit bg-my-gray-95">
            {messagesList.length > 0 ? (
              messagesList.map((message) => (
                <S.ScheduledMessageListItem
                  key={message.id}
                  onClick={() => onSelectMessage(message)}
                >
                  <div className="recipient">
                    <div>To. {message.studentName}</div>
                    <button
                      onClick={async (e) => {
                        e.stopPropagation();
                        onDeleteMessage(message);
                      }}
                    >
                      <CancelFillIcon
                        width="1rem"
                        height="1rem"
                        color="var(--gray-60)"
                      />
                    </button>
                  </div>
                  <div className="time">
                    {DateTime.fromISO(message.scheduledAt).toFormat(
                      'yyyy. M. d EEEE a h:mm',
                      { locale: 'ko' },
                    )}
                  </div>
                  <div className="content">{message.message}</div>
                </S.ScheduledMessageListItem>
              ))
            ) : (
              <div className="w-full p-3 text-center bg-my-gray-100 text-body-md-500 text-my-gray-10">
                예약된 메시지가 없습니다.
              </div>
            )}
          </div>
        </div>
        <S.ScheduledMessagePopupFooter>
          <div></div>
          <BasicButton
            color={'blue'}
            assetType={'Tertiary'}
            size={'Xs'}
            content={'새로 예약'}
            onClickEvent={onClickResetMessageFormButton}
          />
        </S.ScheduledMessagePopupFooter>
      </section>
    </ChatPopupWrapper>
  );
};

export default ScheduledMessageListPopup;
